<button (click)="scan()" [class.primary]="primaryButton()">
  <cue-icon [icon]="cueQrCode" />
  <p>
    {{ translation.navigation.scanQrCode | transloco }}
  </p>
</button>
